(function () {
  'use strict';

  const moneyFormat = window.Shopify && window.Shopify.money_format
    ? window.Shopify.money_format
    : '${{amount}}';

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = (cents / 100).toFixed(2);
    if (moneyFormat.includes('amount_no_decimals')) {
      return moneyFormat.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  /* Mobile nav */
  const menuBtn = qs('[data-menu-toggle]');
  const nav = qs('[data-nav]');
  if (menuBtn && nav) {
    menuBtn.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Product form — variants + qty only; add-to-cart uses native form → cart page */
  const productForm = qs('[data-product-form]');
  if (productForm) {
    const productJsonEl = qs('[data-product-json]');
    let productData = null;
    try {
      productData = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
    } catch (_) {}

    /* Option/qty blocks can sit outside the <form> via the form= attribute */
    const variantInput = qs('[data-variant-id]', productForm);
    const optionSelects = qsa('[data-option-select]');
    const qtyInput = qs('[data-qty-input]');
    const addBtn = qs('[data-add-to-cart]', productForm);
    const priceEl = qs('[data-product-price]');

    function findVariant() {
      if (!productData || !productData.variants) return null;
      const selected = optionSelects.map((s) => s.value);
      return productData.variants.find((v) => {
        return selected.every((val, i) => v[`option${i + 1}`] === val);
      }) || productData.variants[0];
    }

    function onOptionChange() {
      const variant = findVariant();
      if (!variant || !variantInput) return;
      variantInput.value = variant.id;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (priceEl) {
        const money = formatMoney(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML = `<span class="price price--sale">${money}</span><s class="price price--compare">${formatMoney(variant.compare_at_price)}</s>`;
        } else {
          priceEl.innerHTML = `<span class="price">${money}</span>`;
        }
      }
    }

    optionSelects.forEach((s) => s.addEventListener('change', onOptionChange));

    qsa('[data-qty-minus]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!qtyInput) return;
        const v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = v;
      });
    });
    qsa('[data-qty-plus]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!qtyInput) return;
        const v = (parseInt(qtyInput.value, 10) || 1) + 1;
        qtyInput.value = v;
      });
    });
  }

  /* Product thumbs */
  qsa('[data-product-thumb]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const src = btn.getAttribute('data-product-thumb');
      const main = qs('.product-page__image');
      if (main && src) main.src = src;
    });
  });

  /*
   * Freebi injects milestone UI under Buy when no theme app block exists.
   * If the merchant hid/removed the Milestone progress block, remove auto-placed
   * hosts so they cannot reappear under buy buttons.
   */
  function stripFreebiAutoProgress() {
    qsa('[data-freebi-auto-placed="1"], #freebi-progress-auto').forEach((el) => {
      el.remove();
    });
  }
  stripFreebiAutoProgress();
  const mo = typeof MutationObserver !== 'undefined'
    ? new MutationObserver(() => stripFreebiAutoProgress())
    : null;
  if (mo && document.body) {
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /*
   * Motion-style entrance animations (CSS + IntersectionObserver).
   * Framer Motion requires React — this theme is Liquid, so we use a lightweight
   * equivalent for section / card reveals.
   */
  function initMotion() {
    const reduce =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    const pairs = [
      { sel: '.hero--v2 .hero__copy', type: 'fade-up', delay: 0 },
      { sel: '.hero--v2 .hero__visual', type: 'fade-scale', delay: 120 },
      { sel: '.hero-device', type: 'fade-scale', delay: 160 },
      { sel: '.logo-strip .section-header, .logo-strip__heading', type: 'fade', delay: 0 },
      { sel: '.logo-strip__item', type: 'fade-up', stagger: 40 },
      { sel: '.how .section-header', type: 'fade-up', delay: 0 },
      { sel: '.how__step', type: 'fade-up', stagger: 100 },
      { sel: '.demo-grid .section-header', type: 'fade-up', delay: 0 },
      { sel: '.demo-card', type: 'fade-up', stagger: 80 },
      { sel: '.fx__header-copy', type: 'fade-up', delay: 0 },
      { sel: '.fx__metric', type: 'fade-up', stagger: 60 },
      { sel: '.fx-story', type: 'fade-up', stagger: 110 },
      { sel: '.fx-tile', type: 'fade-up', stagger: 35 },
      { sel: '.features .section-header', type: 'fade-up', delay: 0 },
      { sel: '.feature-card', type: 'fade-up', stagger: 45 },
      { sel: '.cta-banner__panel', type: 'fade-scale', delay: 0 },
      { sel: '.product-page__media', type: 'fade', delay: 0 },
      { sel: '.product-page__info > *', type: 'fade-up', stagger: 45 },
    ];

    const targets = [];
    pairs.forEach((cfg) => {
      const nodes = qsa(cfg.sel);
      nodes.forEach((el, i) => {
        if (el.closest('[data-motion-skip]')) return;
        if (el.dataset.motionReady === '1') return;
        el.dataset.motionReady = '1';
        el.classList.add('motion', 'motion--' + (cfg.type || 'fade-up'));
        const delay = (cfg.delay || 0) + (cfg.stagger ? i * cfg.stagger : 0);
        el.style.setProperty('--motion-delay', delay + 'ms');
        targets.push(el);
      });
    });

    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('motion--in'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('motion--in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );

    targets.forEach((el) => {
      // Hero is above the fold — animate in immediately
      if (el.closest('.hero')) {
        requestAnimationFrame(() => el.classList.add('motion--in'));
      } else {
        io.observe(el);
      }
    });
  }

  /* Replace legacy contact emails on policy/contact pages */
  function replaceContactEmails() {
    const from = [
      'info@sntraders.store',
      'suport@freebi.app',
      'support@freebi.app',
    ];
    const to = 'support@freebi.pro';
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      let val = node.nodeValue;
      if (!val) return;
      from.forEach((old) => {
        if (val.indexOf(old) !== -1) val = val.split(old).join(to);
      });
      if (val !== node.nodeValue) node.nodeValue = val;
    });
    qsa('a[href^="mailto:"]').forEach((a) => {
      from.forEach((old) => {
        if (a.href.toLowerCase().indexOf(old.toLowerCase()) !== -1) {
          a.href = 'mailto:' + to;
        }
      });
    });
  }

  function injectRefundPolicyIfEmpty() {
    if (window.location.pathname.indexOf('refund-policy') === -1) return;
    if (qs('.legal-page')) return;
    const main = qs('#MainContent');
    if (!main) return;
    main.innerHTML = `
      <section class="legal-page section">
        <div class="page-width page-width--narrow">
          <p class="legal-page__kicker">Freebi app</p>
          <h1 class="section-title">Refund policy</h1>
          <p class="legal-page__lede">This policy covers charges for the <strong>Freebi</strong> Shopify app. Installing or using Freebi means you agree to it.</p>
          <div class="legal-page__prose rte">
            <p>Freebi is listed on the Shopify App Store. After you install it, the app is available in your admin immediately — campaign tools, storefront widgets, and native discount features. Because that access is delivered as soon as the app is on your shop, <strong>we do not refund charges after Freebi has been installed or used</strong>, except for the billing problems described below.</p>
            <h2>Billing errors we will review</h2>
            <p>A refund is only considered when money was taken because of a <strong>technical or billing fault</strong>, not because you decided the app was not a fit. Typical cases:</p>
            <ul>
              <li>The same subscription period was charged more than once</li>
              <li>Shopify or Freebi kept billing after a completed uninstall</li>
              <li>A confirmed Freebi defect stopped the app from working, and we could not restore it in a reasonable time</li>
            </ul>
            <p>Email us within <strong>seven days of the charge</strong> if you believe one of those happened. Include your shop domain, the date and amount, and what went wrong. We check billing records before deciding. A request is not a guarantee of a refund.</p>
            <h2>Requests we decline</h2>
            <ul>
              <li>You installed Freebi and later changed your mind</li>
              <li>You did not run campaigns, or you unused part of a billing cycle</li>
              <li>You expected a particular lift in AOV, conversions, or gift uptake</li>
              <li>You uninstalled after the app functioned as described in the listing</li>
            </ul>
            <h2>Talk to support</h2>
            <p>For charge questions or anything else about Freebi, write to <a href="mailto:support@freebi.pro">support@freebi.pro</a> or use <a href="/pages/contact-us">Contact us</a>.</p>
            <p class="legal-page__updated">Updated August 2026</p>
          </div>
        </div>
      </section>`;
  }

  function trackAdsEvent(name, extra) {
    const ads = window.FREEBI_ADS || {};
    const payload = Object.assign({ event_category: 'engagement', event_label: name }, extra || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
      const label =
        name === 'app_install' ? ads.installLabel :
        name === 'book_call' ? ads.bookLabel :
        '';
      if (ads.id && label) {
        window.gtag('event', 'conversion', {
          send_to: ads.id + '/' + label,
          value: 1.0,
          currency: 'INR',
          event_callback: extra && extra.event_callback
        });
        return;
      }
    }
    if (extra && typeof extra.event_callback === 'function') {
      extra.event_callback();
    }
  }

  function initAdsClicks() {
    document.addEventListener('click', function (e) {
      const el = e.target.closest('[data-freebi-track]');
      if (!el) return;
      const name = el.getAttribute('data-freebi-track');
      if (!name) return;
      const href = el.getAttribute('href');
      const newTab = el.getAttribute('target') === '_blank';
      if (href && !newTab && href.indexOf('#') !== 0) {
        e.preventDefault();
        let sent = false;
        const go = function () {
          if (sent) return;
          sent = true;
          window.location.href = href;
        };
        trackAdsEvent(name, { event_callback: go });
        setTimeout(go, 400);
      } else {
        trackAdsEvent(name);
      }
    });
  }

  function onReady() {
    replaceContactEmails();
    injectRefundPolicyIfEmpty();
    initMotion();
    initAdsClicks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();

